import App from './App.svelte'

let hmrEnabled = import.meta.hot ? 1:0;
const app = new App({
  target: document.body,
  props: {hmrEnabled},
})

export default app

// recreate the whole app if an HMR update touches this module
if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    app.$destroy()
  })
  import.meta.hot.accept()
}
